module.exports = __webpack_public_path__ + "assets/linear.1ea3a2cf.svg";